import React, { useState } from 'react';
import { withUserWriteAccess } from 'contexts/adminAccess';
import { useDataProvider, useRefresh, useNotify } from 'react-admin';

import { Button, makeStyles } from '@material-ui/core';
import { UserDetails } from '../types';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
}));

interface Props {
  user: UserDetails;
}

const ExpeditedShipmentsButton = ({ user }: Props) => {
  const { expeditedShipmentsAllowedAt, id: rolloId } = user;

  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [loading, setLoading] = useState<boolean>(false);

  const handleToggleExpeditedShipments = async () => {
    try {
      setLoading(true);

      const response = await dataProvider.post('expeditedShipments', {
        userId: rolloId,
        expeditedShipments: !expeditedShipmentsAllowedAt,
      });

      refresh();

      return response;
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleToggleExpeditedShipments}
      disabled={loading}
      className={classes.button}>
      {!!expeditedShipmentsAllowedAt ? 'Disable' : 'Enable'}
    </Button>
  );
};

export default withUserWriteAccess(ExpeditedShipmentsButton);
